/**
 * JavaScript Utility - isObject
 * @author 서명환 <mhseo@ulalalab.com>
 */
function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

export default isObject;
